export const WEEKLY = "Weekly";
export const DAILY = "Daily";
export const MONTHLY = "Monthly";
export const NEVER = "Never";


export const TYPE_ALL = "All";
export const TYPE_ASSIGNED_TO_ME = "Have been assigned to me";



export const NOTIFICATIONS_FREQUENCIES = [WEEKLY, DAILY, NEVER]
export const NOTIFICATIONS_TYPES = [TYPE_ALL, TYPE_ASSIGNED_TO_ME]

// ── Per-post-type notification settings ──────────────────────────────────────
// Drives the per-type accordion in both the personal (ManageNotifications) and
// admin (TeamNotifications) tabs. `type` is the backend STI string and matches
// the keys of the API payload's `notification_settings` hash. `iconName` is a
// DS icon (suitcase is 16px-only). `frequencyOptions` is per-type so a new
// type only needs a config entry here to expose its own cadence set.
const NEVER_DAILY_WEEKLY = [
    { value: NEVER, label: "Never" },
    { value: DAILY, label: "Daily" },
    { value: WEEKLY, label: "Weekly" },
]
const NEVER_WEEKLY_MONTHLY = [
    { value: NEVER, label: "Never" },
    { value: WEEKLY, label: "Weekly" },
    { value: MONTHLY, label: "Monthly" },
]

export const NOTIFICATION_POST_TYPES = [
    { type: "Post", label: "News Results", shortLabel: "News", iconName: "comment", colorKey: "news", supportsMentionedFor: true, frequencyOptions: NEVER_DAILY_WEEKLY },
    { type: "Post::JobUpdates", label: "Job updates", shortLabel: "Job Updates", iconName: "suitcase", colorKey: "job", supportsMentionedFor: false, frequencyOptions: NEVER_WEEKLY_MONTHLY },
    { type: "Post::SecFiling", label: "SEC filings", shortLabel: "SEC filings", iconName: "notes", colorKey: "sec", supportsMentionedFor: false, frequencyOptions: NEVER_DAILY_WEEKLY },
]

// Coverage radio options with the descriptions from the design
export const COVERAGE_OPTIONS = [
    { value: TYPE_ALL, title: "All results", desc: "Every result for this data type, no filtering" },
    { value: TYPE_ASSIGNED_TO_ME, title: "Only prospects assigned to me", desc: "Results from prospects where you are listed as assignee" },
]

// Short coverage label for the collapsed card summary
export const coverageSummaryLabel = (coverage) =>
    coverage === TYPE_ASSIGNED_TO_ME ? "Assigned to me" : "All results"

// Default setting for a single post type. `mentioned_for_enabled` is FE-only
// (UI checkbox state) — it's never sent to the BE; toApiPayload strips it.
export const defaultTypeSetting = (type) => ({
    frequency: type === "Post::JobUpdates" ? WEEKLY : DAILY,
    coverage: TYPE_ALL,
    mentioned_for_enabled: false,
    mentioned_for: [],
})

// Normalize a raw per-type settings hash from the API into the FE state shape.
// Derives `mentioned_for_enabled` from whether any tags are persisted (BE only
// stores tags; the boolean is FE-local UI state).
export const buildTypeSettings = (raw) => {
    const out = {}
    NOTIFICATION_POST_TYPES.forEach(({ type }) => {
        const fromApi = (raw && raw[type]) || {}
        const tags = Array.isArray(fromApi.mentioned_for) ? fromApi.mentioned_for : []
        out[type] = {
            ...defaultTypeSetting(type),
            ...fromApi,
            mentioned_for: tags,
            mentioned_for_enabled: tags.length > 0,
        }
    })
    return out
}

// Strip FE-only fields and honor the local enabled flag before sending to BE:
// when the user has the filter off, send tags=[] regardless of what's in state.
export const toApiPayload = (settings) => {
    const out = {}
    NOTIFICATION_POST_TYPES.forEach(({ type }) => {
        const s = (settings && settings[type]) || {}
        out[type] = {
            frequency: s.frequency,
            coverage: s.coverage,
            mentioned_for: s.mentioned_for_enabled ? (s.mentioned_for || []) : [],
        }
    })
    return out
}

// True when the user has the mentioned_for box on with no tags selected — Save
// must be blocked in that state (Q8). Returns the first offending type or null.
export const findInvalidMentionedFor = (settings) => {
    for (const { type, supportsMentionedFor } of NOTIFICATION_POST_TYPES) {
        if (!supportsMentionedFor) continue
        const s = settings && settings[type]
        if (s && s.mentioned_for_enabled && (!Array.isArray(s.mentioned_for) || s.mentioned_for.length === 0)) {
            return type
        }
    }
    return null
}
